//theme zendesk garden
import { ThemeProvider } from "@zendeskgarden/react-theming";
import { useEffect, useState } from "react";

import Router from "./routes/router";
import { Header } from "@atoms";
import { initializeConfig } from "@service";

const App = () => {
  const [isInitialized, setIsInitialized] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const init = async () => {
      try {
        await initializeConfig();
        setIsInitialized(true);
      } catch (err) {
        console.error("Falha ao inicializar configurações:", err);
        setError("Erro ao carregar configurações da aplicação");
      }
    };

    init();
  }, []);

  if (error) {
    return (
      <div style={{ padding: "20px", color: "red" }}>
        <h2>Erro de Inicialização</h2>
        <p>{error}</p>
      </div>
    );
  }

  if (!isInitialized) {
    return (
      <div style={{ padding: "20px" }}>
        <p>Inicializando aplicação...</p>
      </div>
    );
  }

  return (
    <ThemeProvider>
      <Header />
      <Router />
    </ThemeProvider>
  );
};

export default App;
